<template>
  <div class="text-shadow-none">
    <div class="text-white bg-dark-950 flex flex-col relative">
      <div class="grow min-h-44 relative w-full">
        <!-- <div class="absolute top-0 left-0 right-0 bottom-0 z-10" v-if="place.medias.length > 0">
          <img :src="place.medias[0]?.getSize('m')" class="absolute top-0 left-0 w-full h-full object-cover" />
        </div> -->
        <MapStatic
          :coordinates="place.coordinates"
          is-hide-radius
          :place="place"
          color-theme="dark"
          :is-marker="false"
          :radius="1"
          class="!absolute top-0 left-0 w-full h-full"
          v-if="place.coordinates"
        />

        <div class="absolute left-0 right-0 bottom-0 h-24 bg-gradient-to-t from-dark-950 via-dark-950/70 to-dark-950/0 z-10" />
      </div>

      <div class="p-3.5 shrink-0 relative z-30 -mt-24 min-h-20 text-shadow flex flex-col justify-end">
        <img :src="place.marker.src" class="block w-10 pointer-events-none mb-2 -ml-0.5" v-if="place.marker.src" />
        <div class="text-2xl font-bold !leading-[1.2]">
          <span class="mr-1.5">{{ place.name }}</span>
          
          <IconBase name="cute/verified-gradient" :width="22" v-if="place.isCertified" />
        </div>

        <p class="font-medium text-base mt-2" v-if="place.summary">{{ stripTags(place.summary) }}</p>

        <div class="font-medium text-sm leading-tight text-dark-300 mt-4">
          <span>{{ $t('common.followerCount', { count: toK(place.followerCount ?? 0) }) }}</span> 

          <span v-if="place.isCertified">
            • 
            <IconBase name="cute/verified-fill" :width="18" class="-mt-0.5" />
            {{ $t('components.Organization.certified') }}
          </span>
          <span v-else-if="place.isVerified"> • <IconBase name="cute/check-circle-fill" class="-mt-0.5" :width="14" /> {{ $t('components.Organization.verified') }}</span>
        </div>
      </div>
    </div>
    <div class="bg-light-100 dark:bg-dark-900 text-light-950 dark:text-dark-50">
      <div class="bg-light-200 dark:bg-dark-800 border-b border-light-400 dark:border-dark-700 last:border-none">
        <div class="overflow-auto no-scrollbar">
          <div class="px-2.5 py-3 flex items-center space-x-1.5">
            <ButtonBase color="builders" :is-loading="isFollowLoading" size="xs" class="shrink-0" @click.prevent.stop="onFollow" v-if="!followingPlaces.includes(place._id)">
              <IconBase name="cute/plus-fill" :width="18" class="mr-1" />
              <span class="pr-1.5">{{ $t('actions.follow') }}</span>
            </ButtonBase>

            <ButtonBase size="xs" href="#reviewAdd" :color="followingPlaces.includes(place._id) ? 'base' : 'white'" class="shrink-0" @click="() => isReviewsAdd = true" v-if="!place.hasReviewed(currentUser?._id)">
              <span class="pl-0.5 flex items-center pr-1.5 space-x-1.5 leading-tight">
                <IconBase name="cute/star-fill" class="shrink-0" :width="16" />
                <span class="grow">{{ $t('components.Place.review.add') }}</span>
              </span>
            </ButtonBase>

            <ButtonBase color="xweak" :is-loading="isFollowLoading" size="xs" class="shrink-0" @click.prevent.stop="onFollow" v-if="followingPlaces.includes(place._id)">
              <span class="px-1.5">{{ $t('common.followed') }}</span>
            </ButtonBase>

            <ButtonBase color="white" :to="{ name: 'app-hangout-organize', query: { selectedPlace: place._id }}" class="shrink-0" size="xs">
              <span class="pl-0.5 flex items-center pr-1.5 space-x-1.5 leading-tight">
                <IconBase name="cute/calendar-fill" class="shrink-0" :width="16" />
                <span class="grow">{{ $t('components.Event.actions.organize') }}</span>
              </span>
            </ButtonBase>

            <div class="w-20 shrink-0 h-1" />
          </div>
        </div>

        <div class="px-2.5 -mt-1 pb-2 text-sm font-medium text-light-800 dark:text-dark-400 animate-pulse leading-tight flex space-x-1" v-if="!currentUser?.journey.includes('info-place-follow')">
          <IconBase name="cute/arrow-corner-right" />
          <p class="grow pt-0.5">{{ $t('components.Map.follow.tooltip') }}</p>
        </div>

        <div v-if="stripTags(place.description).length > 0" class="px-3 pb-3">
          <TextHider2
            :content="place.description"
            bg="bg-light-200 dark:bg-dark-800"
            gradient="from-light-200/0 to-light-200 dark:from-dark-800/0 dark:to-dark-800"
            :lines="3"
          >
            <div class="text-body leading-relaxed font-medium" style="color: inherit;" v-html="nl2br(place.description)" />
          </TextHider2>
        </div>
      </div>

      <div class="border-b border-light-400 dark:border-dark-700 last:border-none overflow-hidden">
        <div class="font-medium py-2.5 min-h-12 px-3 hover:bg-light-200 hover:dark:bg-dark-800 cursor-pointer" @click="() => isReviews = !isReviews">
          <div class="flex items-center space-x-2">
            <div
              class="shrink-0 flex items-center text-light-50 dark:text-dark-920 py-1.5 px-2 rounded space-x-1 bg-cover"
              :class="[
                place.rating ? 'text-sm bg-light-950 dark:bg-dark-100 font-black' : 'text-3xs bg-light-600 dark:bg-dark-500 font-medium',
                place.rating && place.rating >= 4 ? '!text-white' : ''
              ]"
              :style="place.rating && place.rating >= 4 ? {
                backgroundImage: `url(${gradient})`
              } : {}"
            >
              <p>{{ place.rating ? toMinFloat(place.rating, 1) : $t('components.Place.index.empty') }}</p>
              <IconBase name="cute/star-fill" :width="15" class="-mt-0.5" v-if="place.rating" />
            </div>
            <div class="grow flex items-center justify-between space-x-1">
              <div>
                <p class="font-bold text-md !leading-tight line-clamp-1 -mt-[1px] break-all">{{ $t('components.Place.index.title') }}</p>
                <p class="text-2xs font-medium !leading-tight text-light-600 dark:text-dark-400" v-if="place.reviewCount">{{ $t('components.Place.review.reviewCount', place.reviewCount) }}</p>
              </div>

              <IconBase name="cute/angle-right" :class="[ isReviews ? 'rotate-90' : '' ]" />
            </div>
          </div>

          <div class="-mx-1 mt-2" v-if="!isReviews && place.rating && (place.reviewsVisible ?? []).filter(r => r.comment).length > 0">
            <CarouselSwipe :auto-swipe="4000" align="left" effect="opacity"  width="full" class="px-0" :spacing="4" pagination="none">
              <template v-for="review in place.reviewsVisible.filter(r => r.comment).sort((a, b) => Number(b.createdAt) - Number(a.createdAt)).slice(0, 6)" #[review._id]>
                <div class="flex items-center space-x-2">
                  <UserPicture :user="usersStore.getItem(review.owner)" size="2xs" />
                  
                  <div class="line-clamp-1 text-sm">
                    {{ review.comment }}
                  </div>
                </div>
              </template>
            </CarouselSwipe>
          </div>
        </div>
        
        <div class="px-3" v-if="isReviews">
          <div class="pt-1 pb-2 text-sm">
            {{ $t('components.Place.index.description') }}
          </div>
          <div class="flex items-start space-x-1.5 py-2 border-b border-light-400 dark:border-dark-700 last:border-none" v-for="review in place.reviewsVisible.sort((a, b) => ((b.comment ? 15 : 1) + b.rating) - ((a.comment ? 15 : 1) + a.rating))" :key="review._id">
            <UserPicture :user="usersStore.getItem(review.owner)" is-link size="xs" />
            
            <div class="grow">
              <div class="flex items-center">
                <p class="text-base font-bold grow leading-none line-clamp-1">{{ usersStore.getItem(review.owner)?.name ?? 'Anonyme' }}</p>
              </div>

              <div class="text-charcoal-300 shrink-0 mt-1 leading-none">
                <IconBase
                  v-for="i in 5"
                  :name="i > review.rating ? 'cute/star-fill' : 'cute/star-gradient'"
                  :width="16"
                />
              </div>

              <p class="text-base leading-tight mt-1.5" v-if="review.comment">{{ review.comment }}</p>

              <div class="flex items-center mt-2">
                <p class="text-xs font-medium text-charcoal-600 grow">{{ dayjs(review.createdAt).fromNow() }}</p>

                <ButtonLink size="xs" class="opacity-50 hover:opacity-100" @click="">
                  {{ $t('actions.report') }}
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="reviewAdd" class="group border-b border-light-400 dark:border-dark-700 last:border-none">
        <div class="font-medium flex items-center hover:bg-light-200 hover:dark:bg-dark-800 space-x-2 py-2.5 min-h-12 px-3 cursor-pointer" @click="() => isReviewsAdd = !isReviewsAdd">
          <IconBase name="cute/pen-fill" />
          <div class="grow">{{ place.hasReviewed(currentUser?._id) ? $t('components.Place.review.edit') : $t('components.Place.review.add') }}</div>

          <div class="text-charcoal-300 shrink-0 align-middle leading-[0]" v-if="place.review(currentUser?._id)">
            <IconBase
              v-for="i in 5"
              :name="i > (place.review(currentUser?._id)?.rating ?? 0) ? 'cute/star-fill' : 'cute/star-gradient'"
              :width="16"
            />
          </div>

          <IconBase name="cute/angle-right" :class="[ isReviewsAdd ? 'rotate-90' : '' ]" />
        </div>
        <div class="p-3 bg-light-300 dark:bg-dark-920" v-if="isReviewsAdd">
          <PlaceSafeRatingForm :place="place" @end="() => isReviewsAdd = false" />
        </div>
      </div>

      <NuxtLink :href="place.urls.website" target="_blank" class="font-medium flex items-center hover:bg-light-200 hover:dark:bg-dark-800 space-x-2 py-2.5 min-h-12 px-3 cursor-pointer group border-b border-light-400 dark:border-dark-700 last:border-none" v-if="place.urls?.website">
        <IconBase name="cute/external" />
        <div class="grow leading-tight line-clamp-1 break-all">{{ beautifyLink(place.urls.website, { path: true }) }}</div>
      </NuxtLink>

      <NuxtLink :to="{ name: 'app-map', query: { coordinates: place.coordinates.join(',') } }" class="relative block" v-if="place.coordinates && isMap">
        <MapStatic
          :coordinates="place.coordinates"
          is-hide-radius
          class="h-32 border-b border-light-400 dark:border-dark-700 last:border-none"
          :place="place"
          is-marker
          :radius="1"
        />

        <div class="absolute bottom-0 right-0 px-2 py-2.5">
          <ButtonBase size="2xs" color="white">
            <IconBase name="cute/map-fill" class="mr-1" :width="16" /> {{ $t('components.Map.open') }}
          </ButtonBase>
        </div>
      </NuxtLink>

      <div class="font-medium flex items-center hover:bg-light-200 hover:dark:bg-dark-800 space-x-2 py-2.5 min-h-12 px-3 cursor-pointer group border-b border-light-400 dark:border-dark-700 last:border-none" @click="() => copyToClipboard(place?.address ?? '')" v-if="place.address">
        <IconBase name="cute/map-marker-fill" />
        <div class="grow leading-tight">{{ place.address }}</div>
        <IconBase name="cute/copy-fill" class="group-hover:opacity-100 opacity-0 text-light-600 dark:text-dark-400" />
      </div>

      <div class="overflow-hidden bg-light-300 dark:bg-dark-920 border-b border-light-400 dark:border-dark-700 last:border-none" v-if="place.medias.length > 0">
        <CarouselScroll padding="p-4" spacing="space-x-1.5" gradient="">
          <div
            class="relative aspect-[9/12] w-32 rounded-lg overflow-hidden" 
            @click="() => popinStore.displayMedias(place.medias, i, 'l')"
            v-for="(media, i) in place.medias"
          >
            <img
              :src="media.getSize('m')"
              loading="lazy"
              class="absolute w-full h-full object-cover"
            />
          </div>
        </CarouselScroll>
      </div>

      <div class="space-y-1.5 p-3 bg-light-300 dark:bg-dark-920 border-b border-light-400 dark:border-dark-700 last:border-none" v-if="(isLoading && place.eventsCount > 0) || events.length > 0">
        <h3 class="text-base font-bold mb-2">{{ $t('components.Place.events') }}</h3>

        <EventCard size="sm" v-for="event in events" :key="event._id" :event="event" />
        <SkeletonBase v-for="i in 6" class="h-20 !bg-charcoal-500/10 rounded-xl" v-if="isLoading" />
      </div>
      
      <div class="font-medium group border-b border-light-400 dark:border-dark-700 last:border-none" @click="() => isClaim = !isClaim" v-if="!place.organization">
        <div class="flex items-center hover:bg-light-200 hover:dark:bg-dark-800 space-x-2 py-2.5 min-h-12 px-3 cursor-pointer">
          <IconBase name="cute/info-circle-fill" />
          <p class="grow">{{ $t('components.Place.claim.title') }}</p>
          <IconBase name="cute/angle-right" :class="[ isClaim ? 'rotate-90' : '' ]" />
        </div>

        <div class="p-3 bg-light-300 dark:bg-dark-920" v-if="isClaim">
          <p class="font-bold text-md leading-snug">{{ $t('components.Place.claim.content', { name: place.name }) }}</p>
          <p class="mt-1 text-sm">{{ $t('components.Place.claim.description') }}</p>

          <ButtonBase :href="useRuntimeConfig().public.BACKSTAGE_URL" target="_blank" class="mt-3" color="base" is-full>{{ $t('components.Place.claim.cta') }}</ButtonBase>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import gradient from '@/assets/img/gradients/hard/gradient-17.jpg'
import WindowStore from '@/store/window'
import UserStore from '@/store/user'
import UsersStore from '@/store/users'
import PopinStore from '@/store/popin'
import PlacesStore from '@/store/places'
import { Event, Place } from '~/classes'
import dayjs from 'dayjs'

const props = withDefaults(defineProps<{
  place: Place,
  events?: Event[]
  isLoading?: boolean
  isMap?: boolean
}>(), {
  events: () => [],
  isLoading: false,
  isMap: true
})

const { place } = toRefs(props)

const emit = defineEmits<{
  (e: 'refresh'): void
}>()

const isClaim = ref(false)

const route = useRoute()
const router = useRouter()

const popinStore = PopinStore()
const placesStore = PlacesStore()

const usersStore = UsersStore()
const windowStore = WindowStore()
const userStore = UserStore()
const { currentUser, followingPlaces } = storeToRefs(userStore)

const isFollowLoading = ref(false)

const onFollow = async () => {
  if (!currentUser.value) return

  isFollowLoading.value = true
  
  if (!currentUser.value.journey.includes('info-place-follow')) await userStore.updateJourney('info-place-follow')

  const response = await placesStore.follow(props.place._id, followingPlaces.value.includes(props.place._id) ? 'unfollow' : 'follow')

  isFollowLoading.value = false
}

const isReviews = ref(false)
const isReviewsAdd = ref(false)
</script>
